"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncProductTree = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const gql_1 = require("../gql");
const get_global_product_tree_query_1 = require("../get-global-product-tree.query");
const client_utils_1 = require("../../client.utils");
const useSyncProductTree = () => {
    const [syncProductTreeMutation] = (0, react_2.useMutation)(gql_1.SYNC_PRODUCT_TREE, {
        update: (cache, { data }, { variables }) => {
            var _a;
            if (!((_a = data === null || data === void 0 ? void 0 : data.syncProductTree) === null || _a === void 0 ? void 0 : _a.success))
                return;
            const { result } = data.syncProductTree;
            const childTreeId = variables === null || variables === void 0 ? void 0 : variables.childTreeId;
            if (!(result === null || result === void 0 ? void 0 : result.lastSyncedAt) || !childTreeId)
                return;
            const cacheId = cache.identify({ __typename: 'ProductTree', id: childTreeId });
            if (!cacheId)
                return;
            cache.modify({
                id: cacheId,
                fields: {
                    lastSyncedAt: () => result.lastSyncedAt,
                    isLinkedToParent: () => true,
                },
            });
        },
    });
    const [linkProductTreesMutation] = (0, react_2.useMutation)(gql_1.LINK_PRODUCT_TREES, {
        update: (cache, { data }, { variables }) => {
            var _a;
            if (!((_a = data === null || data === void 0 ? void 0 : data.linkProductTrees) === null || _a === void 0 ? void 0 : _a.success) || !(variables === null || variables === void 0 ? void 0 : variables.childTreeId))
                return;
            const cacheId = cache.identify({ __typename: 'ProductTree', id: variables.childTreeId });
            if (!cacheId)
                return;
            cache.modify({
                id: cacheId,
                fields: { isLinkedToParent: () => true },
            });
        },
    });
    const [getGlobalProductTree] = (0, react_2.useLazyQuery)(get_global_product_tree_query_1.GET_GLOBAL_PRODUCT_TREE, { fetchPolicy: 'cache-first' });
    const [isSyncing, setIsSyncing] = (0, react_1.useState)(false);
    const ensureLinked = (0, react_1.useCallback)((childTreeId, isLinkedToParent) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (isLinkedToParent)
            return;
        const globalTreeResponse = yield getGlobalProductTree();
        (0, client_utils_1.genericGraphQLErrorsHandler)(globalTreeResponse);
        const parentTreeId = (_e = (_d = (_c = (_b = (_a = globalTreeResponse.data) === null || _a === void 0 ? void 0 : _a.productTrees) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.node) === null || _e === void 0 ? void 0 : _e.id;
        if (!parentTreeId) {
            throw new Error('Global product tree not found');
        }
        const linkResponse = yield linkProductTreesMutation({
            variables: { parentTreeId, childTreeId },
        });
        const linkPayload = (_f = linkResponse.data) === null || _f === void 0 ? void 0 : _f.linkProductTrees;
        if (!(linkPayload === null || linkPayload === void 0 ? void 0 : linkPayload.success)) {
            throw new Error((_g = linkPayload === null || linkPayload === void 0 ? void 0 : linkPayload.error) !== null && _g !== void 0 ? _g : 'Failed to link product trees');
        }
    }), [getGlobalProductTree, linkProductTreesMutation]);
    const syncProductTree = (0, react_1.useCallback)((childTreeId, isLinkedToParent) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        setIsSyncing(true);
        try {
            yield ensureLinked(childTreeId, isLinkedToParent);
            const response = yield syncProductTreeMutation({
                variables: {
                    childTreeId,
                    conflictResolution: graphql_1.ConflictResolution.ParentWins,
                },
            });
            (0, client_utils_1.genericGraphQLErrorsHandler)(response);
            const payload = (_a = response.data) === null || _a === void 0 ? void 0 : _a.syncProductTree;
            if (!(payload === null || payload === void 0 ? void 0 : payload.success)) {
                throw new Error((_b = payload === null || payload === void 0 ? void 0 : payload.error) !== null && _b !== void 0 ? _b : 'Sync failed');
            }
            return payload;
        }
        finally {
            setIsSyncing(false);
        }
    }), [ensureLinked, syncProductTreeMutation]);
    return { syncProductTree, isSyncing };
};
exports.useSyncProductTree = useSyncProductTree;
